import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";

const CommonSwal = ({ isSwalCommon }) => {
    if (!isSwalCommon?.show) return null; // Don't render if not visible

    const { isConfirmLoading } = isSwalCommon;

    const confirmBtnContent = isConfirmLoading ? (
        <span className='custome-swal-confirm-process-main-span'>
            <span className="custome-swal-confirm-process-loader-span" />
            Processing...
        </span>
    ) : (
        isSwalCommon.confirmBtnText
    );

    return (
        <>
            <SweetAlert
                warning={isSwalCommon.type === 'warning'}
                info={isSwalCommon.type === 'info'}
                success={isSwalCommon.type === 'success'}
                error={isSwalCommon.type === 'error'}
                closeOnClickOutside={false}
                title={isSwalCommon.title}
                confirmBtnCssClass={`custom-confirm-button-class${isConfirmLoading ? " swal-confirm-disabled" : ""}`}
                cancelBtnCssClass={`common-custom-cancel-button-class${isConfirmLoading ? " swal-confirm-disabled" : ""}`}
                showCancel={isSwalCommon?.showCancel}
                showConfirm={isSwalCommon?.showConfirm}
                cancelBtnText={isSwalCommon?.cancelBtnText}
                confirmBtnText={confirmBtnContent}
                onConfirm={() => {
                    if (!isConfirmLoading) {
                        isSwalCommon?.onConfirm();
                    }
                }}
                onCancel={() => {
                    if (!isConfirmLoading) {
                        isSwalCommon?.onCancel();
                    }
                }}
            >
                {isSwalCommon.message}
            </SweetAlert>
        </>
    );
};

export default React.memo(CommonSwal);
